var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckCircleOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2077 7.44825L9.16683 13.4891L5.876 10.2074L4.5835 11.4999L9.16683 16.0833L16.5002 8.74992L15.2077 7.44825ZM11.0002 2.33325C5.94016 2.33325 1.8335 6.43992 1.8335 11.4999C1.8335 16.5599 5.94016 20.6666 11.0002 20.6666C16.0602 20.6666 20.1668 16.5599 20.1668 11.4999C20.1668 6.43992 16.0602 2.33325 11.0002 2.33325ZM11.0002 18.8333C6.9485 18.8333 3.66683 15.5516 3.66683 11.4999C3.66683 7.44825 6.9485 4.16659 11.0002 4.16659C15.0518 4.16659 18.3335 7.44825 18.3335 11.4999C18.3335 15.5516 15.0518 18.8333 11.0002 18.8333Z",
    fill: "#2E7D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutlined);
export default __webpack_public_path__ + "static/media/CheckCircleOutlined.bef985a16a3992f93c9afd615d1e96b8.svg";
export { ForwardRef as ReactComponent };